// OPEN ALL EXTERNAL LINKS IN NEW TAB
function targetBlank() {
    var internal = location.host.replace("www.", "");
    internal = new RegExp(internal, "i");
    var a = document.getElementsByTagName('a'); // grab every link on the page
    for (var i = 0; i < a.length; i++) {
        var href = a[i].host; // set the host of shopify link
        if( !internal.test(href) ) { // make sure the href of a element in loop doesn't contain current site's host
            a[i].setAttribute('target', '_blank'); // if it doesn't, set attribute
        }
    }
};
// Run the function targetBlank()
targetBlank();


// Disable links on mega menu parents in the nav
document.querySelectorAll('.f-site-nav__item.f-site-nav__item--has-child a[href="#"]').forEach(link => {
  link.removeAttribute('href');
  link.style.cursor = 'pointer'; // preserve pointer cursor since href is gone
});


// Style the Shopify Forms app
(function() {
  const injectCustomFormStyles = () => {
    // 1. Target the host element from your screenshot
    const shadowHost = document.querySelector('shopify-forms-embed#app-embed');

    if (shadowHost && shadowHost.shadowRoot) {
      // Check if we've already injected the styles to avoid duplicates
      if (shadowHost.shadowRoot.querySelector('.custom-form-styles')) return;

      const style = document.createElement('style');
      style.classList.add('custom-form-styles');
      
      // 2. Add your custom CSS here
      style.textContent = `
        /* Variables */
        :host {
          --form-field-border-radius: 0;
          --form-field-border: 0 0 0 1px var(--color-everglade);
          --button-border-radius: 3px;
          --button-padding: 14px;
          --forms-accent-color: var(--color-text-link);
        }

        /* Container */
        section[data-sizing="form-wrapper"] {
          max-width: 650px !important;
          margin: 0 !important;
        }

        button[class*="formSubmitButton"] {
          font-family: var(--font-btn-family) !important;
          letter-spacing: var(--font-btn-ls) !important;
          text-transform: uppercase !important;
          font-size: var(--font-btn-size) !important;
          padding-bottom: 12px !important;
          width: 220px !important;
          margin-left: auto !important;
          margin-right: auto !important;
          margin-top: 30px !important;
          border: 1px solid var(--button-background-color) !important;
          box-sizing: border-box !important;
        }

        button[class*="formSubmitButton"]:hover {
          opacity: 1 !important;
          background: transparent !important;
          color: var(--button-background-color) !important;
        }

        /* Labels & input fields */
        input[class*="formInputField_"] {
          padding-top: 14px !important;
          padding-bottom: 14px !important;
          padding-left: 10px !important;
          font-family: var(--font-body-family) !important;
          font-size: var(--font-body-size-sm) !important;
        }

        label[class*="formInputFieldLabel_"] {
          top: -25px !important;
          left: 0 !important;
          font-family: var(--font-subheading-family) !important;
          font-size: var(--font-subheading-size) !important;
          letter-spacing: var(--font-subheading-spacing) !important;
          font-weight: var(--font-subheading-weight) !important;
          color: var(--color-everglade-dark) !important;
          text-transform: uppercase;
          transform: none !important;
        }

        div[class*="formFieldContainer_"]:focus-within label[class*="formInputFieldLabel_"] {
          transform: none !important;
        }

        textarea {
          margin-top: 2px;
          padding: 12px !important;
          padding-top: 18px !important;
          font-family: var(--font-body-family) !important;
          font-size: var(--font-body-size-sm) !important;
          height: 180px;
          box-sizing: border-box;
        }

        div[class*="formFieldContainer"]:has(textarea)::before {
          display: none;
        }
        
        div[class*="selectContainer"] p,
        fieldset legend {
          font-family: var(--font-subheading-family) !important;
          font-size: var(--font-subheading-size) !important;
          letter-spacing: var(--font-subheading-spacing) !important;
          font-weight: var(--font-subheading-weight) !important;
          color: var(--color-everglade-dark) !important;
          text-transform: uppercase;
          padding-bottom: 8px !important;
        }

        fieldset label span {
          font-family: var(--font-body-family) !important;
          font-size: var(--font-body-size-sm) !important;
          color: var(--color-everglade) !important;
          margin-left: 12px !important;
        }

        fieldset input {
          width: 18px !important;
          height: 18px !important;
        }

        fieldset {
          margin-bottom: 58px !important;
        }

        fieldset div[class*="horizontalLayout"] {
          grid-template-columns: 1fr 1fr !important;
          row-gap: 16px !important;
        }

        button[class*="selectToggle"] {
          font-family: var(--font-body-family) !important;
          font-size: var(--font-body-size-sm) !important;
          color: var(--color-everglade) !important;
        }

        /* Disclaimer text */
        div[class*="formDisclaimer_"] p {
          font-family: var(--font-body-family) !important;
          font-size: var(--font-body-size-sm) !important;
          color: var(--color-everglade) !important;
        }

        div[class*="formDisclaimer_"] a {
          text-decoration: underline;
        }

        /* Success message */
        section[data-testid="banner-success"] {
          margin-top: 0 !important;
        }
        
        section[data-testid="banner-success"] h2 {
          text-transform: uppercase !important;
        }

        section[data-testid="banner-success"] div[class*="textBody_"] {
          font-family: var(--font-body-family) !important;
          font-size: var(--font-body-size) !important;
        }

        /** Custom Terms Checkbox Styling **/
        /* Wrap the existing disclaimer in a flex row alongside the checkbox */
        .custom-terms-wrapper {
          display: flex;
          align-items: center;
          gap: 10px;
          cursor: pointer;
          position: absolute;
          bottom: 105px;
          left: 50%;
          translate: -50% 0;
        }

        input#customTermsCheckbox {
          margin: 0 !important;
          margin-top: 12px !important;
          width: 18px !important;
          height: 18px !important;
        }

        /* Validation error state */
        .custom-terms-wrapper.terms-error::before {
          border-color: #c0392b;
        }

        .custom-terms-error-msg {
          display: none;
          font-family: var(--font-body-family);
          font-size: var(--font-body-size-sm);
          color: #c0392b;
          margin-top: 4px;
        }

        .custom-terms-error-msg.visible {
          display: block;
        }

        /* Disabled submit button state */
        button[class*="formSubmitButton"].terms-disabled {
          opacity: 0.5 !important;
          cursor: not-allowed !important;
          pointer-events: none !important;
        }

        @media screen and (max-width: 989px) {
          section[class*="formContainer"] {
            min-width: var(--min-form-width) !important;
          }

          /* Mobile container padding top */
          div[class*="gridItemContent"] {
            margin-top: 20px !important
          }

          /* Input fields */
          div[class*="formFieldContainer"] {
            margin-bottom: 18px !important;
        }

          input[class*="formInputField_"] {
            margin-bottom: 20px !important;
          }

          /* Select & radio fields */
        div[class*="selectContainer"] {
          translate: 0 -28px;
        }

          /* Disclaimer text */
          .custom-terms-wrapper {
            bottom: 90px;
          }
        }

        @media screen and (min-width: 990px) {
          /* Desktop container padding top */
          div[class*="gridItemContent"] {
            padding-top: 20px !important;
          }

          form[class*="formFieldset"] {
            display: inline-block !important;
            margin-top: 20px;
          }

          /* Labels & input fields */
        div[class*="formFieldContainer"] {
          width: 48%;
          min-width: unset !important;
          float: left;
          box-sizing: border-box;
        }

        div[class*="formFieldContainer"]:has(textarea) {
          width: 100%;
          margin-bottom: 75px !important;
          margin-top: 30px;
        }

        div[class*="formFieldContainer"]:has(#first_name),
        div[class*="formFieldContainer"]:has(#email) {
          margin-right: 4% !important;
        }

        input#first_name,
        input#last_name {
          margin-bottom: 50px !important;
        }

        input#email,
        input[id*="phone"] {
          margin-bottom: 20px !important;
        }

        /* Select & radio fields */
        div[class*="selectContainer"] {
          margin-bottom: 38px !important;
          clear: both;
        }

        fieldset {
          margin-bottom: 64px !important;
        }
        }
      `;

      shadowHost.shadowRoot.appendChild(style);
      console.log('Shopify Form styles injected successfully.');
    }

    // Finds the first textarea found inside the shadow root and adds placeholder text
    const messageField = shadowHost.shadowRoot.querySelector('textarea');
    if (messageField && !messageField.getAttribute('placeholder')) {
      messageField.setAttribute('placeholder', 'Enter message...');
    }

    injectTermsCheckbox(shadowHost);
  };

  const injectTermsCheckbox = (shadowHost) => {
    const root = shadowHost.shadowRoot;
    if (!root) return;

    // Avoid duplicate injection
    if (root.querySelector('#customTermsCheckbox')) return;

    const disclaimerEl = root.querySelector('div[class*="formDisclaimer"]');
    const submitBtn = root.querySelector('button[class*="formSubmitButton"]');

    if (!disclaimerEl || !submitBtn) return;

    // Create the hidden checkbox input
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.id = 'customTermsCheckbox';

    // Wrap the existing disclaimer div in a label so its native
    // content (editable in the Shopify Forms app) acts as the label text.
    // The wrapper also carries the ::before / ::after pseudo-elements
    // that render the custom checkbox box and fill.
    const wrapper = document.createElement('label');
    wrapper.classList.add('custom-terms-wrapper');
    wrapper.setAttribute('for', 'customTermsCheckbox');

    // Move the disclaimer inside the wrapper, then prepend the checkbox input
    disclaimerEl.parentNode.insertBefore(wrapper, disclaimerEl);
    wrapper.appendChild(checkbox);
    wrapper.appendChild(disclaimerEl);

    // Error message sits directly after the wrapper
    const errorMsg = document.createElement('p');
    errorMsg.classList.add('custom-terms-error-msg');
    errorMsg.textContent = 'Please agree to the terms before submitting.';
    wrapper.insertAdjacentElement('afterend', errorMsg);

    // Intercept the submit button click
    submitBtn.addEventListener('click', (e) => {
      if (!checkbox.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        wrapper.classList.add('terms-error');
        errorMsg.classList.add('visible');
        return false;
      }

      // Clear any error state if checked
      wrapper.classList.remove('terms-error');
      errorMsg.classList.remove('visible');
    }, true); // useCapture ensures this fires before Shopify's handler

    // Toggle checked class for the ::after fill, and clear error on check
    checkbox.addEventListener('change', () => {
      wrapper.classList.toggle('terms-checked', checkbox.checked);
      if (checkbox.checked) {
        wrapper.classList.remove('terms-error');
        errorMsg.classList.remove('visible');
      }
    });

    console.log('Terms checkbox injected successfully.');
  };

  // Observe the document for when the Shopify Form element is added
  const observer = new MutationObserver((mutations, obs) => {
    const form = document.querySelector('shopify-forms-embed#app-embed');
    if (form) {
      injectCustomFormStyles();
      // Optional: keep observing if the form re-renders, 
      // or disconnect if it's a one-time load
      // obs.disconnect(); 
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();